module.exports = __webpack_public_path__ + "static/origin-point.390b69b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/learn/origin-point.jpg
// module id = 1159
// module chunks = 127651196306611